import React from 'react';

import {
  Modal,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  // Well
} from 'react-bootstrap';

import custJqAjax from '../../../commonJS/custJqAjax';


const Comment = props => (
  <div>
    <Row>
      <Col sm={12}>
        <div><span>{props.userName + ':'}</span><span style={{float: 'right', color: 'darkgrey', fontSize: "0.7em"}}>{props.creationTime}</span></div>
      </Col>
    </Row>
    <Row>
      <Col sm={12}>
        <FormGroup>
          <FormControl style={{height: 74}} readOnly={true} value={props.content} componentClass="textarea" />
        </FormGroup>
      </Col>
    </Row>
  </div>
);

export default class DiscussionModal extends React.Component {
  constructor(props) {
    
    super(props);

    this.handlers = {
      textAreaOnChange: e => {
        this.setState({newComment: e.currentTarget.value});
      },
      onSubmit: () => {
        let api, idKey;

        switch(this.props.type) {
          case 'worklog':
            idKey = 'worklog_id';
            api = '/api/W_SaleSky_WorkLog_Discuss_Post.php';
            break;
          case 'repair':
            idKey = 'repair_id';
            api = '/api/M_SaleSky_Repair_Sky_Discuss_Post.php';
            break;
          default:
            
        }

        custJqAjax({
          type: "POST",
          url: api,
          data: {
            [idKey]: this.props.itemId,
            discuss_content: this.state.newComment
          },
          success: data => {
            this.handlers.refreshComments();
            this.setState({newComment: ""});
          }
        });
      },
      refreshComments: () => {
        let api, idKey, countKey;
        
        switch(this.props.type) {
          case 'worklog':
            idKey = 'worklog_id';
            api = '/api/M_SaleSky_WorkLog_Discuss_Get.php';
            countKey = 'worklog_discuss_count';
            break;
          case 'repair':
            idKey = 'repair_id';
            api = '/api/M_SaleSky_Repair_Sky_Discuss_Get.php';
            countKey = 'repair_discuss_count';
            break;
          default:
            
        }

        custJqAjax({
          type: "GET",
          url: api,
          data: {[idKey]: this.props.itemId},
          success: data => {
            if(!data.result) return;
            const comments = data.result.map((item, ind) => 
              <Comment
                key={ind}
                content={item.discuss_content}
                userName={item.user_name}
                creationTime={item.create_time} />
            );

            this.setState({comments});

            // 最小幅度local端更新discussion筆數資料
            let dataWrapper = this.props.sortedData;
            dataWrapper._data[dataWrapper._indexMap[this.props.rowIndex]][countKey] = data.result.length;
          }
        });
      }
    };

    this.state = {
      comments: [],
      newComment: ""
    };
  }

  componentDidMount() {
    this.handlers.refreshComments();
  }

  render() {
    const { languageData, languageCode } = window.myConsts;
    
    return (
      <Modal keyboard={false} backdrop="static" show={this.props.show} bsSize="large">
        <Modal.Header>
          <Modal.Title>
            <span style={{padding: "6px 0px", height: 34, lineHeight: '34px', fontWeight: 'bold'}}>
              Comments
            </span>
            <Button onClick={this.props.closeModal} style={{float: 'right', marginLeft: 5, position: "relative", zIndex: "3"}}>{languageData['452'][languageCode]}</Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{maxHeight: 357/* 3筆高 */, overflow: "auto"}}>
          {this.state.comments}
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col sm={12}>
              <FormGroup controlId="textarea-comment">
                <ControlLabel style={{float: 'left'}}>New Comment</ControlLabel>
                <FormControl value={this.state.newComment} onChange={this.handlers.textAreaOnChange} componentClass="textarea" placeholder="Write comments here" style={{height: 200}} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Button disabled={this.state.newComment ? false : true} onClick={this.handlers.onSubmit} style={{float: 'right', marginLeft: 5, position: "relative", zIndex: "3"}}>送出</Button>
            </Col>
          </Row>
          {/* <Button onClick={this.props.closeModal} style={{float: 'right', marginLeft: 5, position: "relative", zIndex: "3"}}>Close</Button> */}
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/salesky/routes/workLog/DiscussionModal.jsx